// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingOverlay_loading__RA3iU","fade":"LoadingOverlay_fade__FjioZ","completed":"LoadingOverlay_completed__igLxa","open":"LoadingOverlay_open__Yw684"};